
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FeaturedModels() {
  const navigate = useNavigate();

  const featuredModels = [
    {
      id: 1,
      name: 'Championship Trophy',
      category: 'Recognition Stoodio',
      price: 89.99,
      originalPrice: 99.99,
      rating: 4.9,
      reviews: 89,
      image: 'https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/e021f4311b50c904b4d4f02a3f51fd49.png',
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Receptacles',
      category: 'SmartMount Stoodio',
      image: 'https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/43e91f80634d456c39adaec30a11d62c.png',
      printTime: '12 hours',
      material: 'PLA',
      price: '$45.00',
      complexity: 'Intermediate'
    },
    {
      id: 3,
      name: 'Soccer Ball',
      category: 'Lifestyle Stoodio',
      image: 'https://public.readdy.ai/ai/img_res/4ab87120af0419c03f03cb0ced5200ba.jpg',
      printTime: '8 hours',
      material: 'PLA',
      price: '$24.99',
      complexity: 'Intermediate'
    },
    {
      id: 4,
      name: 'Garden Planter',
      category: 'Greenscape Stoodio',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20decorative%20garden%20planter%20with%20geometric%20pattern%2C%20white%20PLA%20material%2C%20modern%20home%20decor%20design%20with%20drainage%20holes%2C%20clean%20product%20photography%20on%20white%20background&width=400&height=400&seq=garden-planter&orientation=squarish',
      printTime: '10 hours',
      material: 'PLA',
      price: '$32.50',
      complexity: 'Beginner'
    },
    {
      id: 5,
      name: 'Robot Action Figure',
      category: 'ModelMaster Stoodio',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20robot%20action%20figure%20with%20articulated%20joints%2C%20futuristic%20design%20in%20silver%20PLA%20material%2C%20detailed%20mechanical%20features%2C%20toy%20photography%20on%20white%20background%20with%20dramatic%20lighting&width=400&height=400&seq=robot-figure&orientation=squarish',
      printTime: '14 hours',
      material: 'PLA',
      price: '$42.00',
      complexity: 'Advanced'
    },
    {
      id: 6,
      name: 'Fidget Spinner',
      category: 'Lifestyle Stoodio',
      image: 'https://readdy.ai/api/search-image?query=3D%20printed%20fidget%20spinner%20with%20smooth%20bearings%2C%20colorful%20PLA%20material%20design%2C%20functional%20stress%20relief%20toy%20with%20balanced%20weight%20distribution%2C%20product%20photography%20on%20white%20background&width=400&height=400&seq=fidget-spinner&orientation=squarish',
      printTime: '4 hours',
      material: 'PLA',
      price: '$18.99',
      complexity: 'Beginner'
    }
  ];

  const handleModelClick = (modelId: number) => {
    navigate(`/model/${modelId}`);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Featured 3D Models</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover our most popular and highest-rated 3D printed models, crafted with precision and attention to detail
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredModels.map((model) => (
            <div key={model.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              {/* Model Image */}
              <div className="relative aspect-square overflow-hidden">
                <img
                  alt={model.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                  src={model.image}
                  onClick={() => handleModelClick(model.id)}
                />
                {model.badge && (
                  <div className="absolute top-4 left-4 bg-[#0069a5] text-white px-3 py-1 rounded-full text-sm font-medium">
                    {model.badge}
                  </div>
                )}
                <button className="absolute top-4 right-4 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-heart-line text-gray-600 hover:text-red-5" />
                </button>
              </div>

              {/* Model Info */}
              <div className="p-6">
                <div className="text-sm text-[#0069a5] font-medium mb-2">{model.category}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0069a5] transition-colors cursor-pointer" onClick={() => handleModelClick(model.id)}>
                  {model.name}
                </h3>

                {/* Rating */}
                <div className="flex items-center gap-2 mb-4">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-${i < Math.floor((model as any).rating ?? 0) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">
                    {(model as any).rating ?? ''} {(model as any).reviews ? `(${(model as any).reviews})` : ''}
                  </span>
                </div>

                {/* Price */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-gray-900">${model.price}</span>
                    {(model as any).originalPrice && (model as any).originalPrice > (model as any).price && (
                      <span className="text-sm text-gray-500 line-through">${(model as any).originalPrice}</span>
                    )}
                  </div>
                  <button
                    onClick={() => handleModelClick(model.id)}
                    className="bg-[#0069a5] hover:bg-[#005a8f] text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <button className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            View All Models
          </button>
        </div>
      </div>
    </section>
  );
}
